import React, { StrictMode } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AddToCart, GetCartDetailsSuccess } from '../../modules/actions/User/getCartDetails.js';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import AlertMsg from './AlertMsg.js';

const cookies = new Cookies();

function AddToCartButton({ size, id, name, to, price, product }) {

    const token = cookies.get('token');
    const dispatch = useDispatch();
    var navigate = useNavigate();
    const cart = useSelector((state) => state.CartDetailsReducer);

    const setCartDataTiStorage = (cartData) => {
        const productData = {
            productId: {
                _id: id || '',
                image: product.image || '',
                name: product.name || '',
                price: product.price || 0,
                displayPrice: product.displayPrice || 0,
                sellingPrice: product.sellingPrice || 0,
                subject: product.subject && product.subject.length > 0 ? product.subject : []
            }
        }

        if (cartData[name] && cartData[name].length > 0) {
            if (cartData[name].some(data => data.productId._id === id)) {
                AlertMsg('error', 'Product already exist in cart')
            } else {
                cartData[name].push(productData);
            }
        } else {
            cartData[name].push(productData);
        }

        localStorage.setItem('cartData', JSON.stringify(cartData));

        dispatch(GetCartDetailsSuccess(cartData));
    }

    const onClick = () => {
        if (!token) {
            let getCartData = JSON.parse(localStorage.getItem('cartData'));
            if (getCartData) {
                setCartDataTiStorage(getCartData);
            } else {
                const cartData = {
                    mockExamsOnline: [],
                    mockExamsOffline: [],
                    PracticePaper: [],
                    ExamPaper: [],
                    TutionPaper: [],
                    Package: []
                }

                setCartDataTiStorage(cartData);
            }
            // navigate('/login');
        } else {
            dispatch(AddToCart(id, name));
        }
    }

    const startTest = () => {
        if (!token) {
            navigate('/login')
        } else {
            navigate(to);
        }
    }

    return (
        <StrictMode>
            {
                price === 0 ?

                    <a href onClick={() => startTest()} className="maincta" style={{ marginLeft: '5px' }}>
                        Start TEST
                    </a> :

                    (_.findIndex(cart[name], function (o) { return o.productId._id === id; }) === -1) &&
                    <a href className="maincta" onClick={() => onClick()} style={{ marginLeft: '5px' }}>
                        <span> ADD TO CART </span><img src="images/arrow.svg" alt="" />
                    </a>
            }
        </StrictMode>
    )
}

export default AddToCartButton;